import { render, staticRenderFns } from "./previewPage.vue?vue&type=template&id=6f20bf89&scoped=true"
import script from "./previewPage.vue?vue&type=script&lang=js"
export * from "./previewPage.vue?vue&type=script&lang=js"
import style0 from "./previewPage.vue?vue&type=style&index=0&id=6f20bf89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f20bf89",
  null
  
)

export default component.exports